import * as React from 'react';
import { getOpenModal, getOpenModalData } from '@/redux/modules/modal';
import { useAppSelector } from '@/redux/hooks';
import { useLocation } from 'react-router-dom';
import AutoPopModalContainer from '@/components/Modals/AutoPop/AutoPopModalContainer';
import loadable from '@loadable/component';
import modalTypes from '@/enums/modalTypes';
import SignUpModalContainer from './SignUp/SignUpModalContainer';

const AbsenteeBidModal = loadable(() => import('./AbsenteeBid/AbsenteeBidModalContainer'));
const AddCreditCardModal = loadable(() => import('./AddCreditCard/AddCreditCardModalContainer'));
const AddressModal = loadable(() => import('./Address/AddressModalContainer'));
const AddSearchAlertModal = loadable(() => import('./AddSearchAlert/AddSearchAlertModal'));
const AddressVerifyModal = loadable(() => import('./AddressVerifyModal/AddressVerifyModal'));
const BidConsoleExplainer = loadable(() => import('./BidConsoleExplainer/BidConsoleExplainer'));
const BidLimitExceededModal = loadable(() => import('./BidLimitExceeded/BidLimitExceededModalContainer'));
const BuyNowModal = loadable(() => import('./BuyNow/BuyNowModalContainer'));
const CatalogAnnouncmentModal = loadable(() => import('./CatalogAnnouncement/CatalogAnnouncementModalContainer'));
const ChangePasswordModal = loadable(() => import('./ChangePassword/ChangePasswordModalContainer'));
const CompleteAccountModal = loadable(() => import('./CompleteAccount/CompleteAccountModal'));
const ConfirmConsignmentModal = loadable(() => import('./ConfirmConsignment/ConfirmConsignmentModalContainer'));
const ConfirmPasswordModal = loadable(() => import('./ConfirmPassword/ConfirmPasswordModalContainer'));
const ConfirmUnfollowSearchModal = loadable(() => import('./ConfirmUnfollowSearch/ConfirmUnfollowSearchModal'));
const DeleteAccountConfirmModal = loadable(() => import('./DeleteAccountConfirm/DeleteAccountConfirmModal'));
const DescriptionModal = loadable(() => import('./Description/DescriptionModal'));
const DownloadMobileModal = loadable(() => import('./DownloadMobile/DownloadMobileModal'));
const ExcludeHouseModal = loadable(() => import('./ExcludeHouse/ExcludeHouseModal'));
const FeedbackModal = loadable(() => import('./Feedback/FeedbackModal'));
const OnTheHuntModal = loadable(() => import('./OnTheHuntModal/OnTheHuntModal'));
const FollowSearchModal = loadable(() => import('./FollowSearch/FollowSearchModalContainer'));
const ForgotPasswordModal = loadable(() => import('./ForgotPassword/ForgotPasswordModalContainer'));
const HealthcheckModal = loadable(() => import('./Healthcheck/HealthcheckModalContainer'));
const LoginModal = loadable(() => import('./Login/LoginModalContainer'));
const RatingsAndReviewsModal = loadable(() => import('./RatingsAndReviews/RatingsAndReviewsModalContainer'));
const ZipInfoModal = loadable(() => import('./ZipInfo/ZipInfoModal'));
const RegisterForAuctionModal = loadable(() => import('./RegisterForAuction/RegisterForAuctionModal'));
const ReportReviewModal = loadable(() => import('./ReportReview/ReportReviewModalContainer'));
const RetractBidModal = loadable(() => import('./RetractBid/RetractBidModalContainer'));
const SendSellerConsignmentMessageModal = loadable(
    () => import('./SendSellerConsignmentMessage/SendSellerConsignmentMessageModal')
);
const SendSellerMessageModal = loadable(() => import('./SendSellerMessage/SendSellerMessageModalContainer'));
const SetPasswordModal = loadable(() => import('./SetPassword/SetPasswordModalContainer'));
const ShippingAndPaymentModal = loadable(() => import('./ShippingAndPayment/ShippingAndPaymentModalContainer'));
const SMSConfirmationModal = loadable(() => import('./SMSConfirmation/SMSConfirmationModal'));
const TaxExemptModal = loadable(() => import('./TaxExempt/TaxExemptModal'));
const WaitingForApprovalModal = loadable(() => import('./WaitingForApproval/WaitingForApprovalModalContainer'));
const ClearCacheModal = loadable(() => import('./ClearCache/ClearCache'));

const Modals = () => {
    const { pathname } = useLocation();
    const openModal = useAppSelector(getOpenModal);
    const modalData = useAppSelector(getOpenModalData);

    return (
        <div>
            <AutoPopModalContainer route={pathname} />
            <SignUpModalContainer />
            <OnTheHuntModal />
            <TaxExemptModal />
            {openModal === modalTypes.ABSENTEE_BID && <AbsenteeBidModal />}
            {openModal === modalTypes.BID_CONSOLE_EXPLAINER && <BidConsoleExplainer />}
            {openModal === modalTypes.ADD_CREDIT_CARD && <AddCreditCardModal />}
            {openModal === modalTypes.ADDRESS && <AddressModal data={modalData} />}
            {openModal === modalTypes.ADD_SEARCH_ALERT && <AddSearchAlertModal />}
            {openModal === modalTypes.ADDRESS_VERIFY_MODAL && <AddressVerifyModal data={modalData} />}
            {openModal === modalTypes.BID_LIMIT_EXCEEDED && <BidLimitExceededModal />}
            {openModal === modalTypes.BUY_NOW && <BuyNowModal />}
            {openModal === modalTypes.CATALOG_ANNOUNCEMENT && <CatalogAnnouncmentModal />}
            {openModal === modalTypes.CHANGE_PASSWORD && <ChangePasswordModal />}
            {openModal === modalTypes.COMPLETE_ACCOUNT && <CompleteAccountModal />}
            {openModal === modalTypes.CONFIRM_CONSIGNMENT && <ConfirmConsignmentModal />}
            {openModal === modalTypes.CONFIRM_PASSWORD && <ConfirmPasswordModal />}
            {openModal === modalTypes.CONFIRM_UNFOLLOW_SEARCH && <ConfirmUnfollowSearchModal />}
            {openModal === modalTypes.DESCRIPTION && <DescriptionModal />}
            {openModal === modalTypes.DOWNLOAD_MOBILE && <DownloadMobileModal />}
            {openModal === modalTypes.EXCLUDE_HOUSE && <ExcludeHouseModal />}
            {openModal === modalTypes.FEEDBACK && <FeedbackModal />}
            {openModal === modalTypes.FOLLOW_SEARCH && <FollowSearchModal />}
            {openModal === modalTypes.FORGOT_PASSWORD && <ForgotPasswordModal />}
            {openModal === modalTypes.HEALTHCHECK && <HealthcheckModal />}
            {openModal === modalTypes.LOGIN && <LoginModal />}
            {openModal === modalTypes.REGISTER_FOR_AUCTION && <RegisterForAuctionModal />}
            {openModal === modalTypes.REPORT_REVIEW && <ReportReviewModal />}
            {openModal === modalTypes.RETRACT_BID && <RetractBidModal />}
            {openModal === modalTypes.REVIEWS && <RatingsAndReviewsModal />}
            {openModal === modalTypes.SEND_SELLER_CONSIGNMENT_MESSAGE && <SendSellerConsignmentMessageModal />}
            {openModal === modalTypes.SEND_SELLER_MESSAGE && <SendSellerMessageModal />}
            {openModal === modalTypes.SET_PASSWORD && <SetPasswordModal />}
            {openModal === modalTypes.SMS_CONFIRMATION && <SMSConfirmationModal />}
            {openModal === modalTypes.DELETE_ACCOUNT_CONFIRMATION && <DeleteAccountConfirmModal />}
            {openModal === modalTypes.SHIPPING_AND_PAYMENT && <ShippingAndPaymentModal />}
            {openModal === modalTypes.WAITING_FOR_APPROVAL && <WaitingForApprovalModal />}
            {openModal === modalTypes.CLEAR_CACHE && <ClearCacheModal />}
            {openModal === modalTypes.ZIP_INFO_MODAL && <ZipInfoModal />}
        </div>
    );
};

export default React.memo(Modals);
